import request from 'superagent';
import api from './core';

export function listAll(page) {
    const url = api.url('/unlinked-contracts/');
    return api.forwardResult(
        api.prepare(request.get(url).query({page})),
        'results',
    );
}

export function fetch(id) {
    const qId = encodeURIComponent(id);
    const contract = api.forwardResult(
        api.prepare(request.get(api.url(`/unlinked-contracts/${qId}/`))), 'id'
    );
    return contract;
}

export function update(contract) {
    const contractData = {...contract};
    const id = encodeURIComponent(contractData.external_id);
    return api.forwardResult(
        api.prepare(request.put(api.url(`/unlinked-contracts/${id}/`))).send(contractData),
        'id'
    );
}

export function importData(id) {
    const qId = encodeURIComponent(id);
    return api.forwardResult(
        api.prepare(request.post(api.url(`/unlinked-contracts/${qId}/import_data/`))),
        'progress_id'
    );

}

export function pendingUnlinkedContracts() {
    return api.forwardResult(
        api.prepare(request.get(api.url('/unlinked-contracts/pending/'))), 'number'
    );
}

export function fetchParameters() {
    return api.forwardResult(
        api.prepare(request.get(api.url('/unlinked-contracts/parameters/'))), 'countries'
    );
}

export function fetchProgress(id) {
    const qId = encodeURIComponent(id);
    return api.forwardResult(
        api.prepare(request.get(api.url(`/unlinked-contracts-progress/${qId}/`))), 'id'
    );
}



// WEBPACK FOOTER //
// ./src/api/unlinked_contracts.js